import DemoCTA from './DemoCTA.jsx';
import TheoLogo from './TheoLogo.jsx';

/* Two product links and one CTA. The page is intentionally
   focused: visitors should land on Theo or OpenCharts, then
   book a walkthrough demo. */
const NAV_LINKS = [
  { href: '#product-theo',   label: 'Theo' },
  { href: '#product-charts', label: 'OpenCharts' },
];

export default function Nav() {
  return (
    <nav className="nav">
      <div className="nav-inner">
        <a href="#top" className="nav-brand" aria-label="Theo home">
          <TheoLogo height={18} style={{ opacity: 0.95 }} />
        </a>
        <div className="nav-links">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="nav-link">
              {link.label}
            </a>
          ))}
        </div>
        <DemoCTA variant="nav" source="nav" label="Book walkthrough demo" />
      </div>
    </nav>
  );
}
